import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import RetailAccordion from "./retailAccordion";

function mapStateToProps(state) {
  return {
    transactions: state.transactions,
    bids: state.bids,
    paymentType: state.paymentType,
    errorFields: state.onSubmitDetails.errorFields,
    errorFlag: state.onSubmitDetails.errorFlag,
    actionType: state.actionType,
    texts :state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  let actionDispatchers = bindActionCreators(actionCreators, dispatch);
  return actionDispatchers;
}

export default connect(mapStateToProps, mapDispatchToProps)(RetailAccordion);
